import { IAppState } from '../../../../../AppModulesWrapper';
import { IRecommendedPackageCheckoutModalData } from '../types';

export const selectRecommendedPackageCheckoutModalData = (state: IAppState): IRecommendedPackageCheckoutModalData => {
  return state.servicePickerWidgetV2.recommendedPackages.checkoutModalData;
};
